import React from 'react';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import VerticleCommentsProgressBar from './vertical-comment-progressbar';
import { accessRoles } from '../../../data/appConstants';

import './index.scss';

const DynamicComment = (props) => {
  const { commentsData, user } = useSelector((state) => {
    return {
      commentsData: state?.OrderSummaryReducer?.comments,
      user: state.loginReducer.user
    };
  });

  const isReseller = user?.roles?.includes(accessRoles.reseller);

  if (!commentsData || commentsData.length === 0) {
    return null;
  }

  return (
    <VerticleCommentsProgressBar
      stepperOption={commentsData}
      title={i18next.t('ORDER_MANAGEMENT.DYNAMIC_COMMENTS.COMMENTS')}
      isReseller={isReseller}
      isPlatformFullfillmentFlow={props?.isPlatformFullfillmentFlow}
    />
  );
};

export default DynamicComment;
